export default __webpack_public_path__ + "static/media/seanmarjasoncom-designs.38363e61.jpg";